import React, { useState } from 'react';
import { Typography, Card, Form, Input, Button, Select, Upload, message, Space } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import MainLayout from '../../layouts/MainLayout';
import { financialApi } from '../../utils/financialApi';
import { extractApiUserMessage } from '../../utils/api';

const { Title, Text } = Typography;
const { Option } = Select;

const RegisterDealPayment = () => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);

  const handleFinish = async (values) => {
    try {
      setLoading(true);
      
      const formData = new FormData();
      formData.append('amount', Number(values.amount));
      formData.append('sales_channel', values.sales_channel);
      formData.append('payment_method_type', values.payment_method_type);
      if (values.tracking_code) formData.append('tracking_code', values.tracking_code);
      formData.append('payment_purpose', values.payment_purpose);
      formData.append('bank_account_id', Number(values.bank_account_id));
      formData.append('paid_on', values.paid_on); // Expected format YYYY-MM-DD HH:mm:ss
      
      if (fileList.length > 0) {
        formData.append('receipt_file', fileList[0].originFileObj || fileList[0]);
      }

      await financialApi.registerDealPayment(Number(values.deal_id), formData);
      message.success('واریزی جدید با موفقیت ثبت شد.');
      form.resetFields();
      setFileList([]);
    } catch (error) {
      message.error(extractApiUserMessage(error) || 'خطا در ثبت واریزی');
    } finally {
      setLoading(false);
    }
  };

  const uploadProps = {
    onRemove: () => {
      setFileList([]);
    },
    beforeUpload: (file) => {
      setFileList([file]);
      return false; // Prevent automatic upload
    },
    fileList,
  };

  return (
    <MainLayout>
      <div className="p-4 md:p-6 pb-24 max-w-[1600px] mx-auto animate-fade-in">
        <div className="mb-6">
          <Title level={3} className="m-0 text-gray-800 dark:text-gray-100 font-bold">
            ثبت واریزی جدید معامله
          </Title>
          <Text className="text-gray-500 dark:text-gray-400">
            ثبت اطلاعات واریز و بارگذاری فیش واریزی برای یک معامله مشخص
          </Text>
        </div>

        <Card bordered={false} className="shadow-sm dark:bg-gray-800 rounded-2xl max-w-2xl">
          <Form form={form} layout="vertical" onFinish={handleFinish}>
            <Form.Item name="deal_id" label="شناسه معامله (Deal ID)" rules={[{ required: true }]}>
              <Input type="number" placeholder="مثال: 85" />
            </Form.Item>
            
            <Form.Item name="amount" label="مبلغ (تومان)" rules={[{ required: true }]}>
              <Input type="number" />
            </Form.Item>

            <Form.Item name="sales_channel" label="کانال فروش" rules={[{ required: true }]}>
              <Select placeholder="انتخاب کنید">
                <Option value="b2b">B2B</Option>
                <Option value="online">آنلاین</Option>
                <Option value="phone">تلفنی</Option>
                <Option value="in_person">حضوری</Option>
              </Select>
            </Form.Item>

            <Form.Item name="payment_method_type" label="روش پرداخت" rules={[{ required: true }]}>
              <Select placeholder="انتخاب کنید">
                <Option value="bank_transfer">حواله بانکی</Option>
                <Option value="card_to_card">کارت به کارت</Option>
                <Option value="pos">کارتخوان (POS)</Option>
                <Option value="cash">نقدی</Option>
              </Select>
            </Form.Item>

            <Form.Item name="payment_purpose" label="بابت" rules={[{ required: true }]}>
              <Select placeholder="انتخاب کنید">
                <Option value="invoice">فاکتور</Option>
                <Option value="down_payment">پیش‌پرداخت</Option>
                <Option value="installment">قسط</Option>
                <Option value="settlement">تسویه نهایی</Option>
              </Select>
            </Form.Item>

            <Form.Item name="bank_account_id" label="شناسه حساب بانک مقصد" rules={[{ required: true }]}>
              <Input type="number" />
            </Form.Item>

            <Form.Item name="tracking_code" label="کد پیگیری">
              <Input />
            </Form.Item>

            <Form.Item name="paid_on" label="تاریخ و ساعت واریز" rules={[{ required: true }]} help="فرمت: YYYY-MM-DD HH:mm:ss">
              <Input placeholder="2026-09-29 11:30:00" />
            </Form.Item>

            <Form.Item label="فیش واریزی (اختیاری)">
              <Upload {...uploadProps} maxCount={1}>
                <Button icon={<UploadOutlined />}>انتخاب فایل تصویر</Button>
              </Upload>
            </Form.Item>

            <Form.Item className="mb-0 pt-4 border-t border-gray-100 dark:border-gray-700 flex justify-end">
              <Space>
                <Button onClick={() => form.resetFields()}>انصراف</Button>
                <Button type="primary" htmlType="submit" loading={loading}>
                  ثبت واریزی
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </Card>
      </div>
    </MainLayout>
  );
};

export default RegisterDealPayment;
